import { useState, useEffect, useCallback } from 'react';
import { Row, Col, Typography } from 'antd';
import TranscriptConfig from "@/config/transcript";
import SectionConfig from "@/config/section";
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";
import { ClassType, ClassSubjectListType } from "@/containers/organization/classManagement/types";
import { TranscriptListType } from './types';
import StudentTable from './StudentTable';

const { getTranscriptList } = TranscriptConfig;
const { getClassByUserAccountId, getClassSubject } = SectionConfig;

type Props = {
  studentInfo: StudentType;
  examId: number;
  year: string;
}

function StudentSingle(props: Props) {
  const { studentInfo, examId, year } = props;
  const { timePeriodName, className, userAccountId } = studentInfo;
  const [transcriptList, setTranscriptList] = useState<TranscriptListType>({});
  const [classInfo, setClassInfo] = useState({} as ClassType);
  const [subjectInfo, setSubjectInfo] = useState<ClassSubjectListType>({});

  useEffect(() => {
    getTranscriptListFunction();
    getClassByUserAccountIdFunction();
  }, [userAccountId, examId]);

  const getTranscriptListFunction = useCallback(() => {
    const params = {
      examId,
      studentIds: [userAccountId],
    };

    getTranscriptList(params).then((res: any) => {
      const transcriptList = res?.value ?? {};
      setTranscriptList(transcriptList);
    });
  }, [examId, userAccountId]);

  const getClassByUserAccountIdFunction = useCallback(() => {
    getClassByUserAccountId({ userAccountId }).then((res: any) => {
      const classInfo = res?.value ?? {};
      setClassInfo(classInfo);

      getClassSubject({ classId: classInfo.classId }).then((res: any) => {
        const subjectInfo = res?.value ?? [];

        setSubjectInfo(subjectInfo);
      });
    });
  }, [userAccountId]);

  return (
    <Row gutter={[8, 0]} justify="center">
      <Col>
        <Typography.Title level={3}>
          {`${timePeriodName} - ${className}`}
        </Typography.Title>
      </Col>

      <Col span={24}>
        {Object.keys(transcriptList).length > 0 &&
          <StudentTable
            studentArray={[studentInfo]}
            transcriptList={transcriptList}
            examId={examId}
            getTranscriptListFunction={getTranscriptListFunction}
            subjectInfo={subjectInfo}
            classInfo={classInfo}
            year={year}
          />
        }
      </Col>
    </Row>
  )
}

export default StudentSingle;